import React, { useContext } from "react";
import Money from "components/money";
import CookingHub from "components/cooking-hub";
import translations from "locales";
import * as styles from "./style.mod.scss";
import { trackBeginCheckout } from "helpers/analytics";
import GlobalContext from "services/global-context";

const CartFooter = ({ pdpSettings }) => {
  const cartLoc = translations?.cart;
  const { cart } = useContext(GlobalContext);
  const discountedTotal = +cart?.totalPriceV2?.amount;
  const undiscountedPrice = discountedTotal + cart?.totalSavings + cart?.discountedAmount;

  const goToCheckout = (url) => {
    trackBeginCheckout(cart, "shopify");
    try {
      const linkerParam = window.ga?.getAll()[0]?.get("linkerParam");
      if (linkerParam === undefined) {
        window.open(url, "_self");
        return;
      } else {
        window.open(`${url}&${linkerParam}`, "_self");
      }
    } catch (error) {
      console.log(error);
      window.open(url, "_self");
    }
  };


  return (
    <div className={styles.snippetAndCta}>
      {pdpSettings?.showOnCart && <div className={styles.chefSnippet}> <CookingHub data={pdpSettings} /></div>}
      <div className={styles.sum}>
        <div className={styles.shipping}>
          <span>{cartLoc.shipping}</span>
          <span className={styles.highlightText}>{cartLoc.gratis}</span>
        </div>
        <div className={styles.shipping}>
          <span>{cartLoc.return}</span>
          <span className={styles.highlightText}>{cartLoc.gratis}</span>
        </div>
        <div className={styles.total}>
          <span>{cartLoc.sum}<span>{cartLoc.incVAT}</span></span>
          <span className={styles.totality}>
            <div className={styles.saved}>
              {(undiscountedPrice !== discountedTotal) && <Money value={undiscountedPrice} />}
            </div>
            <Money value={discountedTotal} showZero={true}/>
          </span>
        </div>
        <button id="checkoutButton" className={styles.checkoutButton} onClick={() => goToCheckout(cart.webUrl)}>{cartLoc.addToCart}</button>
      </div>
    </div>
  );
};

export default CartFooter;